import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Collapse } from "reactstrap"
import { Link } from "react-router-dom"
import "../../assets/css/Layout/Header.css"
import Configs from "../../config"
import { FaBarsProgress, FaUserXmark } from "react-icons/fa6"
import {
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaHome,
  FaUsers,
  FaPoundSign,
  FaSalesforce,
  FaFileAlt,
  FaBoxOpen,
  FaTruck,
  FaList,
} from "react-icons/fa"
import {
  MdCleaningServices,
  MdSettings,
  MdQuestionAnswer,
  MdStackedLineChart,
} from "react-icons/md"
import { BsClipboard2DataFill } from "react-icons/bs"
import { MdOutlineSecurity } from "react-icons/md"
import { usePermissionData } from "AppContext"

const Navbar = props => {
  const [dashboard, setdashboard] = useState(false)
  const [setting, setSetting] = useState(false)
  const [expense, setExpense] = useState(false)

  const { checkAccess } = usePermissionData()

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    removeActivation(items)
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement
      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active")
        }
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div className="topnav ps-1 pe-0" style={{ zIndex: "1001" }}>
        <div className="container-fluid px-0">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav d-flex justify-content-between w-100">
                <div className="d-flex">
                  {/* dashboard */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}dashboard`}
                    >
                      <FaHome size={18} className="me-2 mb-1" />
                      {"Home"} {props.menuOpen}
                    </Link>
                  </li>

                  {(checkAccess(1, "viewGlobal") || checkAccess(1, "view")) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}inventory`}
                      >
                        <FaFileAlt size={18} className="me-2 mb-1" />
                        {"Inventory"} {props.menuOpen}
                      </Link>
                    </li>
                  )}
                  {(checkAccess(2, "viewGlobal") || checkAccess(2, "view")) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}product`}
                      >
                        <FaBoxOpen size={18} className="me-2 mb-1" />
                        {"Product"} {props.menuOpen}
                      </Link>
                    </li>
                  )}
                  {(checkAccess(3, "viewGlobal") || checkAccess(3, "view")) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}vendor`}
                      >
                        <FaTruck size={18} className="me-2 mb-1" />
                        {"Vendor"} {props.menuOpen}
                      </Link>
                    </li>
                  )}
                  {(checkAccess(4, "viewGlobal") || checkAccess(4, "view")) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}staff`}
                      >
                        <FaUsers size={18} className="me-2 mb-1" />
                        {"Staff"} {props.menuOpen}
                      </Link>
                    </li>
                  )}
                  {(checkAccess(6, "viewGlobal") || checkAccess(6, "view")) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}audit-logs`}
                      >
                        <FaList size={18} className="me-2 mb-1" />
                        {"Audit Logs"} {props.menuOpen}
                      </Link>
                    </li>)}

                  <li className="nav-item dropdown">
                    <button className="btn nav-link dropdown-toggle arrow-none">
                      <MdSettings size={18} className="me-2 mb-1" />
                      {"Settings"} {props.menuOpen}
                    </button>
                    <div className="dropdown-menu" id="sales-dropdown">
                      {(checkAccess(5, "viewGlobal") || checkAccess(5, "view")) && (
                        <Link
                          to={`${Configs.appurl}roles`}
                          className="text-dark dropdown-item"
                        >
                          Roles & Permissions
                        </Link>
                      )}

                      {/* <Link
                        to={`${Configs.appurl}pos-names`}
                        className="text-dark dropdown-item"
                      >
                        POS Sheet Names
                      </Link> */}

                      {(checkAccess(7, "viewGlobal") || checkAccess(7, "view")) && (
                        <Link
                          to={`${Configs.appurl}departments`}
                          className="text-dark dropdown-item"
                        >
                          Department Name
                        </Link>
                      )}
                      {(checkAccess(8, "viewGlobal") || checkAccess(8, "view")) && (
                        <Link
                          to={`${Configs.appurl}category`}
                          className="text-dark dropdown-item"
                        >
                          Category Name
                        </Link>
                      )}
                      {(checkAccess(9, "viewGlobal") || checkAccess(9, "view")) && (
                        <Link
                          to={`${Configs.appurl}classnames`}
                          className="text-dark dropdown-item"
                        >
                          Class Name
                        </Link>
                      )}
                      {(checkAccess(10, "viewGlobal") || checkAccess(10, "view")) && (
                        <Link
                          to={`${Configs.appurl}programs`}
                          className="text-dark dropdown-item"
                        >
                          Program Builds
                        </Link>
                      )}
                      {(checkAccess(11, "viewGlobal") || checkAccess(11, "view")) && (
                        <Link
                          to={`${Configs.appurl}stone`}
                          className="text-dark dropdown-item"
                        >
                          Stone
                        </Link>
                      )}
                      {(checkAccess(12, "viewGlobal") || checkAccess(12, "view")) && (
                        <Link
                          to={`${Configs.appurl}brand`}
                          className="text-dark dropdown-item"
                        >
                          Brand
                        </Link>
                      )}
                      {(checkAccess(13, "viewGlobal") || checkAccess(13, "view")) && (
                        <Link
                          to={`${Configs.appurl}store`}
                          className="text-dark dropdown-item"
                        >
                          Store
                        </Link>
                      )}

                      {(checkAccess(14, "viewGlobal") || checkAccess(14, "view")) && (
                        <div className="dropdown-submenu">
                          <span className="text-dark dropdown-item d-flex justify-content-between align-items-center">
                            <span>
                              <FaList size={13} className="me-2" />
                              VM Code
                            </span>
                            <span className="dropdown-submenu-arrow">
                              &#9656;
                            </span>
                          </span>
                          <div className="dropdown-menu dropdown-submenu-menu">
                            <Link
                              to={`${Configs.appurl}vm-code-five`}
                              className="text-dark dropdown-item"
                            >
                              VM Code 5
                            </Link>
                            <Link
                              to={`${Configs.appurl}vm-code-six`}
                              className="text-dark dropdown-item"
                            >
                              VM Code 6
                            </Link>
                            <Link
                              to={`${Configs.appurl}vm-code-seven`}
                              className="text-dark dropdown-item"
                            >
                              VM Code 7
                            </Link>
                            <Link
                              to={`${Configs.appurl}vm-code-eight`}
                              className="text-dark dropdown-item"
                            >
                              VM Code 8
                            </Link>
                          </div>
                        </div>
                      )}

                      {(checkAccess(14, "viewGlobal") || checkAccess(14, "view")) && (
                        <div className="dropdown-submenu dropdown-submenu-up">
                          <span className="text-dark dropdown-item d-flex justify-content-between align-items-center">
                            <span>
                              <FaList size={13} className="me-2" />
                              Component Type
                            </span>
                            <span className="dropdown-submenu-arrow">
                              &#9656;
                            </span>
                          </span>
                          <div className="dropdown-menu dropdown-submenu-menu">
                            <Link
                              to={`${Configs.appurl}component-type-one`}
                              className="text-dark dropdown-item"
                            >
                              Component Type 1
                            </Link>
                            <Link
                              to={`${Configs.appurl}component-type-two`}
                              className="text-dark dropdown-item"
                            >
                              Component Type 2
                            </Link>
                            <Link
                              to={`${Configs.appurl}component-type-three`}
                              className="text-dark dropdown-item"
                            >
                              Component Type 3
                            </Link>
                            <Link
                              to={`${Configs.appurl}component-type-four`}
                              className="text-dark dropdown-item"
                            >
                              Component Type 4
                            </Link>
                            <Link
                              to={`${Configs.appurl}component-type-five`}
                              className="text-dark dropdown-item"
                            >
                              Component Type 5
                            </Link>
                          </div>
                        </div>
                      )}

                      {(checkAccess(15, "viewGlobal") || checkAccess(15, "view")) && (
                        <Link
                          to={`${Configs.appurl}promotion-code`}
                          className="text-dark dropdown-item"
                        >
                          Promotion Code
                        </Link>
                      )}
                    </div>
                  </li>

                  {/* <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}services`}
                    >
                      <MdCleaningServices size={18} className="me-2 mb-1" />
                      {"Services"} {props.menuOpen}
                    </Link>
                  </li> */}

                  {/*<li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}locations`}
                    >
                      <FaMapMarkerAlt size={18} className="me-2 mb-1" />{" "}
                      Locations
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}payroll-report`}
                    >
                      <FaPoundSign size={18} className="me-2 mb-1" /> Payroll
                      
                    </Link>
                  </li>

                   <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}user-query`}
                    >
                      <MdQuestionAnswer size={18} className="me-2 mb-1" /> Query
                    </Link>
                  </li>

                   */}
                </div>
              </ul>
              {/* <Dropdown>
                <DropdownToggle nav caret className="text-white">
                  <MdSettings className="me-2" />
                  Settings
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem>
                    <Link
                      to={`${Configs.appurl}locations`}
                      className="text-dark"
                    >
                      <FaLocationPin className="me-2" /> Locations
                    </Link>
                  </DropdownItem>
                  <DropdownItem>
                    <Link to={`${Configs.appurl}roles`} className="text-dark">
                      <FaUser className="me-2" /> Roles
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown> */}
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

export default Navbar
